/** A pickable option that has a name and a logo — and nothing else. The select
 * grid renders these without knowing they happen to be fund issuers, or where
 * the logo was fetched from. */
export interface LogoOption {
  id: string;
  name: string;
  logoUrl?: string;
}

export interface Option<T> {
  id: T;
  label: string;
}

export enum VALID_ASSET_TYPES {
  ALL = "NO_SELECTED_ASSET",
  SWEDEN_STOCKS = "SA",
  GLOBAL_STOCKS = "GA",
  ALTERNATIVE = "3ALTINV",
  NOMINAL = "NR",
  REALA = "RR",
}

export enum HOLDINGS_SETTINGS {
  ALL = "All",
  PORTFOLIO = "Portfolio",
}
